import React from 'react';
import { Box, Skeleton } from '@skin-seoul/design-system';
import { Carousel } from '@/components/ui/Carousel';
const CategoryCardSkeleton = () => {
  return <Box width="108px" height="108px" borderRadius="50%" backgroundColor="generic.0" display="flex" flexFlow="column" alignItems="center" gap={2} padding={3} data-sentry-element="Box" data-sentry-component="CategoryCardSkeleton" data-sentry-source-file="CategorySliderSkeleton.tsx">
      <Skeleton width="48px" height="48px" borderRadius="50%" data-sentry-element="Skeleton" data-sentry-source-file="CategorySliderSkeleton.tsx" />
      <Skeleton width="80px" height="14px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CategorySliderSkeleton.tsx" />
    </Box>;
};
const CategorySliderSkeleton = () => {
  return <Box width="100%" overflow="hidden" data-sentry-element="Box" data-sentry-component="CategorySliderSkeleton" data-sentry-source-file="CategorySliderSkeleton.tsx">
      <Carousel opts={{
      loop: false,
      align: 'start',
      skipSnaps: false,
      dragFree: true
    }} w="100%" data-sentry-element="Carousel" data-sentry-source-file="CategorySliderSkeleton.tsx">
        <Carousel.Content data-sentry-element="Carousel.Content" data-sentry-source-file="CategorySliderSkeleton.tsx">
          {Array.from({
          length: 6
        }).map((_, index) => <Carousel.Item key={index} flexBasis="auto" px={3} py={2}>
              <CategoryCardSkeleton />
            </Carousel.Item>)}
        </Carousel.Content>
      </Carousel>
    </Box>;
};
export default CategorySliderSkeleton;